export default {
  title: 'Zapłać przez {{method}}',
  hint: 'Następnie potwierdzisz płatność w banku lub w swojej aplikacji.',
  continue: 'Kontynuuj',
  cancel: 'Anuluj płatność',
  unavailable: 'Ta metoda płatności jest obecnie niedostępna. Wybierz inną.',
};
